import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCheckBox = () => {
  return (
    <g>
      <path d="m1.05 1 10.201.01a.75.75 0 0 1-.001 1.5L1.5 2.5v10.999h13V7.752a.75.75 0 0 1 .648-.743l.102-.007a.75.75 0 0 1 .743.648l.007.102v6.198c0 .541-.41.987-.936 1.044L14.95 15H1.05a1.05 1.05 0 0 1-1.044-.936L0 13.95V2.05c0-.54.41-.986.936-1.043L1.051 1zm14.733 1.718a.72.72 0 0 1 .069.955l-.073.082-7.263 7.033a.766.766 0 0 1-.98.067l-.083-.071-3.234-3.18a.72.72 0 0 1 .004-1.037.766.766 0 0 1 .979-.068l.084.072L7.99 9.23l6.73-6.516a.765.765 0 0 1 1.063.004z" />
    </g>
  );
};

export default withIcon(IconCheckBox);
